import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import WebErrorBoundary from "@/components/WebErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));
if (process.env.REACT_APP_CAPACITOR_APP_ROLE === "admin") {
  window.__SHONAN_ADMIN_BOOT__?.setPhase?.("react-bundle-loaded", "React bundle loaded");
}
root.render(
  <React.StrictMode>
    {/^(admin|driver|dispatcher|fleet)$/.test(process.env.REACT_APP_CAPACITOR_APP_ROLE || "") ? <App /> : <WebErrorBoundary><App /></WebErrorBoundary>}
  </React.StrictMode>,
);
if (process.env.REACT_APP_CAPACITOR_APP_ROLE === "admin") {
  window.__SHONAN_ADMIN_BOOT__?.setPhase?.("react-render-requested", "React root render requested");
}
